import { LayoutPageTabs, TabConfig } from '@/components/layouts/LayoutPageTabs';
import { useUser } from '@/hooks';
import { BarChart3, Bot, Building2, CreditCard, Link as LinkIcon, Settings as SettingsIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BillingSection } from './BillingSection';
import { GeneralSection } from './GeneralSection';
import { HubsSection } from './HubsSection';
import { IntegrationsTab } from './integrations/IntegrationsTab';
import { NeoSection } from './NeoSection';
import { UsageSection } from './UsageSection';

export function Settings() {
  const { data: memberContext } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const memberId = memberContext?.selectedMember?.id ?? 0;
  const isHubAdmin = memberContext?.selectedMember?.isAdmin === true;
  const isIntegrationsPath = location.pathname.startsWith('/settings/integrations');
  const activeTab: 'general' | 'integrations' | 'billing' | 'usage' | 'hubs' | 'neo' =
    location.pathname.endsWith('/usage')
      ? 'usage'
      : location.pathname.endsWith('/billing')
        ? 'billing'
        : location.pathname.endsWith('/hubs')
          ? 'hubs'
          : location.pathname.endsWith('/neo')
            ? 'neo'
            : isIntegrationsPath
              ? 'integrations'
              : 'general';

  const tabs: TabConfig[] = [
    {
      id: "general",
      label: "General",
      icon: SettingsIcon,
      content: <GeneralSection />
    },
    {
      id: "integrations",
      label: "Integrations",
      icon: LinkIcon,
      content: <IntegrationsTab memberId={memberId} isHubAdmin={isHubAdmin} />,
    },
    {
      id: "hubs",
      label: "Hubs",
      icon: Building2,
      content: <HubsSection />
    },
    {
      id: "neo",
      label: "Neo",
      icon: Bot,
      content: <NeoSection />
    },
    {
      id: "billing",
      label: "Billing",
      icon: CreditCard,
      content: <BillingSection />
    },
    {
      id: "usage",
      label: "Usage",
      icon: BarChart3,
      content: <UsageSection />
    },
  ];

  return (
    <LayoutPageTabs
      tabs={tabs}
      defaultTab={activeTab}
      onTabChange={(tabId) => {
        if (tabId === 'general' || tabId === 'integrations' || tabId === 'billing' || tabId === 'usage' || tabId === 'hubs' || tabId === 'neo') {
          navigate(`/settings/${tabId}`);
        }
      }}
      onTabClick={(tabId) => {
        if (tabId === 'integrations' && location.pathname !== '/settings/integrations') {
          navigate('/settings/integrations');
        }
      }}
    />
  );
} 